(<template>
  <section class="retract-compliance">
    <div class="retract-compliance__icon"></div>
    <h3 class="retract-compliance__subtitle">{{ $gettext('Retract consent') }}</h3>
    <p class="retract-compliance__description">{{ $gettext('Are you sure you want to retract consent? You won’t be suitable for In-person jobs.') }}</p>
    <div class="retract-compliance__buttons">
      <button class="sk-btn sk-btn--white retract-compliance__button"
              @click="closeModal">{{ $gettext('Back') }}</button>
      <button class="sk-btn retract-compliance__button retract-compliance__button--action"
              @click="retractCompliance">{{ $gettext('Retract') }}</button>
    </div>
  </section>
</template>)

<script>
  export default {
    props: {
      data: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    watch: {
      $route() {
        this.closeModal();
      }
    },
    methods: {
      closeModal() {
        this.$store.dispatch('ModalStore/closeModal');
      },
      retractCompliance() {
        this.data.context.sendFolkeregisterConsent('declined');
        this.closeModal();
      },
    }
  };
</script>

<style scoped>
  .retract-compliance {
    margin-top: -15px;
    padding: 0 30px 30px;
    background-color: var(--color-white);
  }

  .retract-compliance__icon {
    width: 48px;
    height: 48px;
    background: center no-repeat url(~@assets/imgs/salita/secure/verification_warning_icon.svg);
  }

  .retract-compliance__subtitle {
    margin: 24px 0 16px 0;
    font-size: 1.45rem;
  }

  .retract-compliance__description {
    margin-bottom: 24px;
  }

  .retract-compliance__buttons {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
  }

  .retract-compliance__button {
    width: fit-content;
    padding: 0 12px;
  }

  .retract-compliance__button--action {
    background-color: var(--color-error-600);
    color: var(--color-white);
  }

  .retract-compliance__button--action:hover {
    opacity: 0.8;
  }
</style>
